module.exports = __webpack_public_path__ + "static/media/46986.94ff04ae.gif";